import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiChevronRight, FiX } from "react-icons/fi";

const GoalSelector = ({ isOpen, onClose }) => {
    const [activeTab, setActiveTab] = useState("Management");

    if (!isOpen) return null;

    const categories = [
        { id: "Management", icon: "👔", label: "Management" },
        { id: "Engineering", icon: "⚙️", label: "Engineering" },
        { id: "Medical", icon: "🩺", label: "Medical" },
        { id: "Arts", icon: "🎨", label: "Arts" },
        { id: "Commerce", icon: "📊", label: "Commerce" },
        { id: "Design", icon: "✏️", label: "Design" },
    ];

    const courses = {
        Management: ["MBA", "BBA", "PGDM", "BMS", "Executive MBA"],
        Engineering: ["B.Tech", "M.Tech", "Diploma in Engg", "B.Arch", "Mechatronics"],
        Medical: ["MBBS", "BDS", "BAMS", "BHMS", "Pharmacy"],
        Arts: ["BA", "MA", "BFA", "Journalism", "Psychology"],
        Commerce: ["B.Com", "M.Com", "CA", "CS", "CFA"],
        Design: ["Fashion Design", "Interior Design", "Graphic Design", "Animation"],
    };

    return (
        <div className="absolute top-14 left-0 w-full md:w-[600px] bg-white rounded-lg shadow-2xl z-50 border border-gray-100 overflow-hidden animate-fadeIn">
            <div className="flex bg-gray-50 border-b border-gray-100 p-3 justify-between items-center">
                <h3 className="text-gray-800 font-bold text-sm uppercase tracking-wide">Select Your Study Preference</h3>
                <button onClick={onClose} className="text-gray-500 hover:text-red-500 transition">
                    <FiX size={18} />
                </button>
            </div>

            <div className="flex h-[350px]">
                {/* Sidebar */}
                <div className="w-1/3 bg-gray-100 border-r border-gray-200 overflow-y-auto">
                    {categories.map((cat) => (
                        <button
                            key={cat.id}
                            onClick={() => setActiveTab(cat.id)}
                            className={`w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-all ${activeTab === cat.id
                                    ? "bg-white text-orange-600 border-l-4 border-orange-500 shadow-sm"
                                    : "text-gray-600 hover:bg-gray-200"
                                }`}
                        >
                            <span className="text-lg">{cat.icon}</span>
                            {cat.label}
                        </button>
                    ))}
                </div>

                {/* Content */}
                <div className="w-2/3 p-5 overflow-y-auto">
                    <h4 className="text-gray-900 font-bold mb-4 flex items-center gap-2">
                        <span className="text-orange-500">
                            {categories.find(c => c.id === activeTab)?.icon}
                        </span>
                        Top {activeTab} Courses
                    </h4>
                    <div className="grid grid-cols-2 gap-3">
                        {courses[activeTab]?.map((course) => (
                            <Link
                                key={course}
                                to={`/c_pages/${course}`}
                                onClick={onClose}
                                className="flex items-center justify-between px-3 py-2 bg-gray-50 hover:bg-orange-50 border border-gray-200 hover:border-orange-200 rounded-md text-xs font-semibold text-gray-700 hover:text-orange-700 transition"
                            >
                                {course}
                                <FiChevronRight className="text-gray-400 group-hover:text-orange-400" />
                            </Link>
                        ))}
                    </div>

                    <div className="mt-6 pt-4 border-t border-gray-100">
                        <Link to="/all-courses" className="text-xs font-bold text-blue-600 hover:underline">
                            View All {activeTab} Courses &rarr;
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GoalSelector;
